import React from 'react';
import {
  Card,
  Typography,
  Skeleton,
  Alert,
  Button,
  List,
  ListItem,
  ListItemText,
  Divider,
  Chip,
  Stack,
  Box,
} from '@mui/material';
import Iconify from '../../iconify/Iconify';

const formatDateTime = (value) => {
  if (!value) return 'NA';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return 'NA';
  return date.toLocaleString();
};

export default function RecentActivityFeed({ rows, loading, error, onRetry }) {
  const items = (rows || []).slice(0, 12);

  return (
    <Card
      sx={{
        p: 2.25,
        borderRadius: 3,
        border: '1px solid',
        borderColor: 'divider',
        boxShadow: '0 8px 22px rgba(16, 24, 40, 0.05)',
        height: '100%',
      }}
    >
      <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 1.5 }}>
        <Iconify icon="solar:clock-circle-bold-duotone" width={18} />
        <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>
          Recent Activity
        </Typography>
      </Stack>
      <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 1, fontSize: { xs: '0.72rem', md: '0.75rem' } }}>
        Latest operational events
      </Typography>

      {error ? (
        <Alert
          severity="error"
          action={
            <Button color="inherit" size="small" onClick={onRetry}>
              Retry
            </Button>
          }
        >
          Failed to load recent activity.
        </Alert>
      ) : loading ? (
        <Skeleton variant="rectangular" height={320} sx={{ borderRadius: 2 }} />
      ) : (
        <List sx={{ p: 0, maxHeight: 360, overflowY: 'auto' }}>
          {items.map((item, index) => (
            <React.Fragment key={`${item.consignmentNo || 'activity'}-${item.at || index}`}>
              <ListItem sx={{ px: 0, py: 0.9 }}>
                <Box
                  sx={{
                    width: 10,
                    height: 10,
                    borderRadius: '50%',
                    bgcolor: 'primary.main',
                    mr: 1.2,
                    mt: 0.6,
                    flexShrink: 0,
                  }}
                />
                <ListItemText
                  primary={
                    <Stack direction="row" spacing={1} alignItems="center" flexWrap="wrap">
                      <Typography variant="caption" sx={{ fontWeight: 700, letterSpacing: 0.15 }}>
                        {item.type || 'Activity'}
                      </Typography>
                      {item.status ? <Chip size="small" label={item.status} variant="outlined" /> : null}
                    </Stack>
                  }
                  primaryTypographyProps={{ lineHeight: 1.2 }}
                  secondaryTypographyProps={{ variant: 'caption' }}
                  secondary={`${item.consignmentNo ? `CN: ${item.consignmentNo} | ` : ''}${formatDateTime(item.at)}`}
                />
              </ListItem>
              {index < items.length - 1 ? <Divider /> : null}
            </React.Fragment>
          ))}
          {!items.length ? (
            <Typography variant="body2" color="text.secondary">
              No recent activity found.
            </Typography>
          ) : null}
        </List>
      )}
    </Card>
  );
}
